import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Calendar, CalendarOptions, DateSelectArg, DatesSetArg, EventClickArg } from '@fullcalendar/core';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import allLocales from '@fullcalendar/core/locales-all';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import scrollGridPlugin from '@fullcalendar/scrollgrid';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { DatePipe } from '@angular/common';
import { EventImpl } from '@fullcalendar/core/internal';

@Component({
  selector: 'split-full-calendar',
  templateUrl: './split-full-calendar.component.html',
  styleUrls: ['./split-full-calendar.component.scss']
})
export class SplitFullCalendarComponent implements OnChanges{
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  @Input() events: any[] = [];
  @Input() professionals: any[] = [];

  @Input() height: string = "calc(100vh - 104px)";

  @Output() onSelect: EventEmitter<EventImpl> = new EventEmitter<EventImpl>();
  @Output() onClick: EventEmitter<EventImpl> = new EventEmitter<EventImpl>();
  public showSelection: boolean = false;
  public selectedInfo: any = {};
  public activedSectionSettings: any = "query";

  calendarOptions: CalendarOptions = {
    initialView: 'resourceTimeGridDay',
    height: this.height,
    headerToolbar: false,
    plugins: [resourceTimeGridPlugin, interactionPlugin, scrollGridPlugin],
    schedulerLicenseKey: '0366497652-fcs-1709044105',
    allDaySlot: false,
    locales: allLocales,
    locale: 'pt-br',
    timeZone: 'America/Sao_Paulo',
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    },
    slotLabelInterval: {
      minutes: 30
    },
    datesSet: this.datesSet.bind(this),
    select: this.select.bind(this),
    eventClick: this.eventClick.bind(this),
    editable: true,
    droppable: true,
    selectable: true,
    selectMirror: true,
    eventMinHeight: 60,
    snapDuration: '00:05',
    dayMinWidth: 400,
    views: {
      resourceTimeGridThreeDay: {
        type: 'resourceTimeGrid',
        duration: { days: 3 }
      }
    },
    datesAboveResources: true,
  };

  constructor(private datePipe: DatePipe) {}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['height']) {
      this.calendarOptions.height = this.height;
    }
  }

  modifyDate(event: any) {
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.gotoDate(event);
  }

  cancelEvent() {
    if(this.selectedInfo?.id) {
      this.selectedInfo.remove();
    }
    this.showSelection = false;
  }

  eventClick(eventClickArg: EventClickArg) {
    this.onSelect.emit(eventClickArg.event);
  }
 
  
  datesSet(datesSetArg: DatesSetArg) {
    let mouth = this.datePipe.transform(datesSetArg.startStr, 'MMM')?.toUpperCase().slice(0, -1);
    let day = this.datePipe.transform(datesSetArg.startStr, 'dd');
    let calendarApi = this.calendarComponent.getApi();
    let query = <HTMLElement>calendarApi.el.querySelector('.fc-timegrid-axis-frame')
    query.innerHTML = `
      <div class="flex flex-column align-items-center justify-content-center">
        <div class="mouth">${mouth}</div>
        <div class="day">${day}</div>
      </div>
    `;
  }

  select(dateSelectArg: DateSelectArg) {
    this.showSelection = true;
    let calendar: Calendar = this.calendarComponent.getApi();
    if(this.selectedInfo?.id) {
      calendar.getEventById(this.selectedInfo.id)?.remove();
    }

    
    this.selectedInfo = calendar.addEvent({
      id: this.selectedInfo.lenght + 1,
      title: "New Event",
      start: dateSelectArg.startStr,
      end: dateSelectArg.endStr,
      resourceId: dateSelectArg.resource?.id
    });

    calendar.unselect();
    if(this.selectedInfo != null) {
      this.onSelect.next(this.selectedInfo); 
    }
  }

  nextDay() {
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.next();
    return calendarApi.getDate();
  }

  previousDay() {
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.prev();
    return calendarApi.getDate();
  }

  goToDay() {
    let calendarApi = this.calendarComponent.getApi();
    calendarApi.today();
    return calendarApi.getDate();
  }

  getDate() {
    let calendarApi = this.calendarComponent.getApi();
    return calendarApi.getDate();
  }

}
